/**
 * Data e hora de Brasília para exibição na ADM.
 *
 * Quem opera está no Brasil e o servidor grava em UTC: mostrar o instante no
 * fuso do navegador (alguém da equipe viajando, um notebook mal configurado)
 * faria o "aceitou às 08:00" virar outra hora. Por isso a conversão é explícita
 * aqui, e não `toLocaleString()`.
 *
 * O Brasil não tem horário de verão desde 2019, então America/Sao_Paulo é
 * UTC-03:00 o ano inteiro. Se isso mudar, é este arquivo que muda.
 *
 * Recorte do utilitário homônimo do posexpert: só o que a tela de aceites usa.
 */

/** Offset fixo de America/Sao_Paulo, em minutos. */
export const BRT_OFFSET_MINUTES = -180;

/** Data (`AAAA-MM-DD`) e hora (`HH:MM`) de Brasília de um instante em UTC. */
export function utcIsoToBrtFields(iso?: string | Date | null): {
  date: string;
  time: string;
} {
  if (!iso) return { date: '', time: '' };

  const parsed = iso instanceof Date ? iso : new Date(iso);
  if (Number.isNaN(parsed.getTime())) return { date: '', time: '' };

  // Deslocar o instante para BRT e ler os campos em UTC: evita depender do fuso
  // da máquina de quem está usando a ADM.
  const shifted = new Date(parsed.getTime() + BRT_OFFSET_MINUTES * 60 * 1000);
  const pad = (n: number) => String(n).padStart(2, '0');

  return {
    date: `${shifted.getUTCFullYear()}-${pad(shifted.getUTCMonth() + 1)}-${pad(shifted.getUTCDate())}`,
    time: `${pad(shifted.getUTCHours())}:${pad(shifted.getUTCMinutes())}`,
  };
}

/** `28/08/2026 08:00` — como a data aparece na tabela da ADM. */
export function formatBrtDateTime(iso?: string | Date | null): string {
  const { date, time } = utcIsoToBrtFields(iso);
  if (!date) return '';

  const [year, month, day] = date.split('-');
  return `${day}/${month}/${year} ${time}`;
}
